import clsx from "clsx";
import { LtIconKey } from "react-migration/domains/constraints/designation/style/icons";
import { Icon } from "react-migration/components/Icon";
import { LoadingIndicator } from "./LoadingIndicator";

interface SearchIconLoadingIndicatorProps {
  icon: LtIconKey;
  loading?: boolean;
  className?: string;
}

export function SearchIconLoadingIndicator({ icon, loading = false, className }: SearchIconLoadingIndicatorProps) {
  return (
    <div className={clsx("h-full w-10", className)}>
      <Icon
        icon={`icon-${icon}`}
        size="lg"
        extraClasses="text-neutral-800 absolute top-0 right-0 bottom-0 left-0 z-10 flex items-center justify-center text-neutral-800 text-xl sm:block content-center text-center"
      />
      <div className="absolute top-0 right-0 bottom-0 left-0 z-10 flex items-center justify-center">
        <LoadingIndicator show={loading} className="bg-white" />
      </div>
    </div>
  );
}
